import { render, staticRenderFns } from "./CreateActor.vue?vue&type=template&id=725de22a&"
import script from "./CreateActor.vue?vue&type=script&lang=js&"
export * from "./CreateActor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports